export default __webpack_public_path__ + "static/media/add_product-stap_01.b3930aae.png";